// Same normalization for storing and for the blind-index lookup, so both sides hash the same string.
export const normalizeEmail = (email: string): string => email.trim().toLowerCase();

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string): boolean => EMAIL_PATTERN.test(email.trim());
